import React from 'react';
import './StatusBadge.css';

const StatusBadge = ({ status, variant = 'default' }) => {
  const getStatusConfig = (status, variant) => {
    const statusLower = String(status).toLowerCase();
    
    const configs = {
      default: {
        activo: { className: 'status-success', text: 'Activo' },
        active: { className: 'status-success', text: 'Active' },
        activa: { className: 'status-success', text: 'Activa' },
        vigente: { className: 'status-success', text: 'Vigente' },
        inactivo: { className: 'status-danger', text: 'Inactivo' },
        inactive: { className: 'status-danger', text: 'Inactive' },
        inactiva: { className: 'status-danger', text: 'Inactiva' },
        vencido: { className: 'status-warning', text: 'Vencido' },
        expirado: { className: 'status-warning', text: 'Expirado' },
        pending: { className: 'status-warning', text: 'Pendiente' },
        pendiente: { className: 'status-warning', text: 'Pendiente' },
        suspended: { className: 'status-secondary', text: 'Suspendido' },
        suspendida: { className: 'status-secondary', text: 'Suspendida' },
        deleted: { className: 'status-secondary', text: 'Eliminado' },
        eliminado: { className: 'status-secondary', text: 'Eliminado' },
      },
      binary: {
        '1': { className: 'status-success', text: 'Sí' },
        '0': { className: 'status-danger', text: 'No' },
        true: { className: 'status-success', text: 'Sí' },
        false: { className: 'status-danger', text: 'No' },
      }
    };

    return configs[variant]?.[statusLower] || configs.default[statusLower] || 
           { className: 'status-default', text: status };
  };

  const config = getStatusConfig(status, variant);

  return (
    <span className={`status-badge ${config.className}`} role="status" aria-label={config.text}>
      {config.text}
    </span>
  );
};

export default React.memo(StatusBadge);